




















import Vue from "vue";
import Component from "vue-class-component";
@Component({
  components: {}
})
export default class Swiper extends Vue {
  private newsImageList = [];
  created() {
    // this.getBannerList()
  }
  // banner列表
  private async getBannerList() {
    const res = await this.$axios("getBannerList");
    this.newsImageList = res.data.data.filter(v => v.bannerUrl);
  }
  private goDetail(id) {
    this.$router.push({ name: "详情", params: { id } });
  }
}
